import * as _4 from 'lodash4';
import { TimeUtility } from 'utility-ts-type';
import { Comment } from '../../comments/builders/comment_builder';
import { APCourse } from '../../global/builders/ap_course_builder';
import { APCourseGroup } from '../../global/builders/ap_course_group_builder';
import { APTerm } from '../../global/builders/ap_term_builder';
import { IAPChangelogStrategy } from '../strategies/ap_changelog_strategy';

export type proposer = 'ADVISOR' | 'STUDENT';
export type change_type = 'move' | 'add' | 'remove' | '';
export interface IGenericUser {
  first_name: string;
  id: number;
  last_name: string;
}

export interface IAPSuggestedPlanItem {
  course: APCourse;
  course_group: APCourseGroup;
  id: number;
  is_locked: boolean;
  comment?: string;
  proposer: proposer;
  term: APTerm;
  slot_status: 'MET' | 'UNMET' | 'COMMENT_ONLY' | null;
  slot_type: 'COURSE' | 'GROUP' | 'WILDCARD' | 'NCR' | null;
}

export interface IAPSuggestedPlanResolution {
  id: number;
  resolution: proposer;
  suggested_plan_changes: IAPSuggestedPlanItem[];
}

export class APChangelog {
  advisor: IGenericUser;
  committed_by: IGenericUser;
  committed_ts: string;
  comments: Array<Partial<Comment>>;
  created_ts: string;
  edited_by: IGenericUser;
  edited_ts: string;
  id: number;
  _changelogDisplay: IAPChangelogStrategy[];
  last_change_time: string;
  suggested_plan_resolutions: IAPSuggestedPlanResolution[];
  updated_ts: string;

  constructor(change: Partial<APChangelog>) {
    const TIME_FORMAT = 'MMMM Do, YYYY - h:mmA';
    _4.merge(change, {
      _formattedCommittedTime: TimeUtility.formatTime(TIME_FORMAT, change.committed_ts || ''),
      _formattedCreatedTime: TimeUtility.formatTime(TIME_FORMAT, change.created_ts || ''),
      _formattedEditedTime: TimeUtility.formatTime(TIME_FORMAT, change.edited_ts || ''),
      _formattedLastChangeTime: TimeUtility.formatTime(TIME_FORMAT, change.last_change_time || ''),
      _changelogDisplay: []
    });

    _4.merge(this, change);
  }

  static build(change: Partial<APChangelog>): APChangelog {
    return new APChangelog(change);
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/changelog/builders/ap_changelog_builder.ts